
import draggable from "vuedraggable";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import {
  Param,
  ParamType
} from "@/lib/model/exambuilder/exam-component/params";
import Pop from "../components/blue-pop.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import ParamEdit from "@/views/ai-builder-component/components/param-edit.vue";

@Component({
  components: {
    ParamEdit,
    draggable,
    Pop,
    HinaSwitch,
    HinaRadioGroup,
    IntroduceCard
  }
})
export default class ParamsCom extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  loginTypeOptions = [
    { name: "手机号验证码 + 姓名", value: 1 },
    { name: "手机号验证码", value: 0 }
  ];

  skipTypeOptions = [
    { name: "信息不全不跳过", value: 0 },
    { name: "首次或信息不全不跳过", value: 1 },
    { name: "不跳过", value: 2 }
  ];

  get hasBgCheck() {
    return this.formItemData.bgCheck.configData.bgCheckProductId !== 0;
  }

  // 人脸核验
  get hasLivenessRecognition() {
    return (
      this.formItemData.livenessRecognition.use === 1 ||
      this.formItemData.nameIdCheck.use === 1
    );
  }

  get allParams() {
    return this.formItemData.allParams;
  }

  get defaultParams() {
    return this.formItemData.defaultParams;
  }

  get selectedParams() {
    return this.formItemData.paramList.filter(item => item.isShow === 1);
  }

  get hasBmi() {
    const bmi = this.allParams.find(item => item.inputType === "bmi");

    if (bmi?.isShow === 1) {
      return true;
    }

    return false;
  }

  handleChangeBmi(list: Param[], msg = false) {
    // 处理bmi 和 身高体重
    const bmi = list.find(item => item.inputType === "bmi");
    const height = list.find(item => item.inputType === "height");
    const weight = list.find(item => item.inputType === "weight");

    if (bmi?.isShow === 1) {
      if (msg) {
        if (height?.isShow === 1 || weight?.isShow === 1) {
          this.$message.warning(
            "BMI为特殊字段，添加该字段，会覆盖已选择的身高、体重字段"
          );
        } else {
          this.$message.warning(
            "BMI为特殊字段，添加该字段，会默认添加身高、体重字段"
          );
        }
      }

      if (height) {
        height.isShow = bmi.isShow;
        height.saveLater = bmi.saveLater;
        height.canUpdate = bmi.canUpdate;
        height.isRequired = bmi.isRequired;
        height.showConfigList = bmi.showConfigList;
      }

      if (weight) {
        weight.isShow = bmi.isShow;
        weight.saveLater = bmi.saveLater;
        weight.canUpdate = bmi.canUpdate;
        weight.isRequired = bmi.isRequired;
        weight.showConfigList = bmi.showConfigList;
      }
    }
  }

  change() {
    // 更新父组件中的paramList，确保保持同步
    this.$emit("change", {
      paramList: this.allParams,
      allParams: this.allParams
    });
    this.$emit("setBar", false);
  }

  @Watch("formItemData.paramList", { deep: true, immediate: true })
  initParams() {
    this.splitSelectedList();
  }

  handleChangeParams(v: number) {
    if (v === 1) {
      if (this.frontendParamsBackup.length) {
        this.frontendParams = JSON.parse(
          JSON.stringify(this.frontendParamsBackup)
        );
      } else {
        console.log(this.formItemData);
        this.frontendParams = JSON.parse(JSON.stringify(this.defaultParams));
      }
    } else {
      this.frontendParamsBackup = JSON.parse(
        JSON.stringify(this.frontendParams)
      );
      this.frontendParams.forEach(item => (item.isShow = 0));
    }

    this.paramSelected();
  }

  // 交互已选项
  frontendParamsBackup: Param[] = [];
  frontendParams: Param[] = [];
  behindParams: Param[] = [];

  checkDragable(item: Param) {
    return (
      item.inputType === ParamType.ShortIdCard ||
      item.name === "身份证号" ||
      item.name === "姓名" ||
      item.name === "手机"
    );
  }

  selectedParam = "选择已有字段";

  // 登记信息 下拉框内可用的字段
  getSelectOptions(saveLater = 0) {
    if (saveLater === 0) {
      return this.frontendParams.filter(el => {
        return el.name !== "姓名" && el.name !== "手机" && el.isShow !== 1;
      });
    } else {
      return this.behindParams.filter(el => {
        return el.isShow !== 1;
      });
    }
  }

  select(item: Param) {
    console.log("🚀 ~ ParamsCom ~ select ~ item:", item);
    const i = this.allParams.findIndex(d => d.name === item.name);

    if (i !== -1 && item.inputType === ParamType.IdCard && this.hasBgCheck) {
      return this.$message.warning("背调服务已开启，需候选人身份证号");
    }

    if (
      i !== -1 &&
      item.inputType === ParamType.IdCard &&
      this.hasLivenessRecognition
    ) {
      return this.$message.warning(
        "身份核验(人脸核验)已开启，需候选人身份证号"
      );
    }

    if (item.isShow === 1) {
      // 检测是否被作为条件使用
      let hasUsedName = "";
      const hasShowUsed = this.allParams.some(p => {
        if (p.isShow === 2) return false;

        const hasShowUsed = p.showConfigList.some(
          c => c[0]?.matchParamIndex === item.paramIndex
        );

        if (hasShowUsed) {
          hasUsedName = p.name;
        }

        return hasShowUsed;
      });

      if (hasShowUsed) {
        return this.$message.warning(
          `当前字段【${item.name}】被其他字段【${hasUsedName}】用作前置条件，不能删除。请先删除【${hasUsedName}】`
        );
      }
    } else {
      const indexList = item.showConfigList
        .map(c => c[0]?.matchParamIndex || 0)
        .filter(id => !!id);

      const canShow = indexList.every(index =>
        this.allParams.some(p => p.isShow === 1 && p.paramIndex === index)
      );

      // if (!canShow) {
      //   return this.$message.warning(
      //     `当前字段【${item.name}】的前置条件字段【${names.join(",")}】未展示`
      //   );
      // }
    }

    item.isShow = item.isShow === 1 ? 2 : 1;
    this.allParams[i].isShow = item.isShow;

    this.handleChangeBmi(this.allParams, item.inputType === "bmi");
    this.splitSelectedList();
  }

  // needSendCaptcha(item: Param) {
  //   if (this.hasBgCheck && item.captchaCheck === 1) {
  //     this.$message.warning("背调服务已开启，需短信验证码校验候选人手机号");
  //     return;
  //   }

  //   item.captchaCheck = item.captchaCheck === 1 ? 2 : 1;
  // }

  // 处理前置后置列表
  splitSelectedList() {
    this.frontendParams = [];
    this.behindParams = [];

    // 使用Map来确保每个字段名称只出现一次
    const uniqueParams = new Map();

    // 优先处理已选择的字段（isShow === 1）
    this.allParams.forEach(el => {
      if (el.isShow === 1 && !uniqueParams.has(el.name)) {
        uniqueParams.set(el.name, el);
      }
    });

    // 然后处理未选择的字段（isShow !== 1）
    this.allParams.forEach(el => {
      if (el.isShow !== 1 && !uniqueParams.has(el.name)) {
        uniqueParams.set(el.name, el);
      }
    });

    // 将唯一字段重新分配到frontendParams和behindParams
    uniqueParams.forEach(el => {
      if (el.saveLater === 0) {
        this.frontendParams.push(el);
      } else {
        this.behindParams.push(el);
      }
    });

    this.change();
    this.$forceUpdate();
  }

  paramSelected() {
    const list = [
      ...this.frontendParams,
      ...this.behindParams
    ].map((item, index) => ({ ...item, paramIndex: index + 1 }));

    this.$emit("change", { paramList: list, allParams: list });
  }

  sortAdd(key: string) {
    (this[key] as Param[]).forEach(item => {
      item.saveLater = key === "frontendParams" ? 0 : 1;
    });

    this.handleChangeBmi(this.allParams);
    this.splitSelectedList();
  }

  // 是否条件字段
  showOp(item: Param) {
    return item?.showConfigList?.[0]?.[0]?.matchParamIndex;
  }

  // 条件展示文案
  showOpText(item: Param) {
    const fa = this.allParams.find((d: any) => {
      return d.paramIndex == item.showConfigList?.[0]?.[0]?.matchParamIndex;
    });

    let t = ``;

    fa?.fIdList.forEach((d: any, i: number) => {
      item.showConfigList.forEach((m: any, n: number) => {
        if (d == m[0].fId) {
          t += `[${fa.singleChoiceOptions[i] || fa.mutiChoiceOptions[i].key}] `;
        }
      });
    });

    return { name: fa?.name, text: t };
  }

  editParam?: Param = new Param();
  showRegis = false;

  editRegis(item: Param) {
    this.editParam = item;
    this.showRegis = true;
  }

  addRegis(saveLater?: boolean) {
    this.editParam = undefined;
    this.showRegis = true;

    if (saveLater) {
      this.$nextTick(() => {
        const RegisEdit = this.$refs.RegisEdit as any;
        RegisEdit.formData.saveLater = 1;
      });
    }
  }

  editOk(params: Param, edit: Param) {
    if (edit) {
      // 编辑模式 - 检查是否与其他字段重名（排除当前编辑的字段）
      const duplicate = this.allParams.find(
        d => d.name === params.name && d.paramIndex !== edit.paramIndex
      );

      if (duplicate) {
        this.$message.warning("字段名称不能重复");
        return;
      }

      // 确保paramIndex是有效值
      if (!edit.paramIndex || edit.paramIndex < 1) {
        console.warn("检测到无效的paramIndex值:", edit.paramIndex);
        // 查找当前编辑的参数在数组中的位置
        const foundIndex = this.allParams.findIndex(
          p =>
            p.name === edit.name ||
            (p.paramIndex && p.paramIndex === edit.paramIndex)
        );

        if (foundIndex >= 0) {
          edit.paramIndex = foundIndex + 1; // 索引从1开始
        } else {
          // 如果找不到匹配的参数，则使用数组长度作为新索引
          edit.paramIndex = this.allParams.length + 1;
        }
      }

      // 编辑已有字段 - 确保保留原始isShow状态
      params.isShow = edit.isShow;
      params.paramIndex = edit.paramIndex; // 确保保留原始的paramIndex

      // 计算基于paramIndex的编辑索引
      let editIndex = Number(edit.paramIndex) - 1;

      // 如果计算的索引无效，尝试通过名称查找正确的索引
      if (editIndex < 0 || editIndex >= this.allParams.length) {
        console.warn("计算的editIndex无效:", editIndex);

        // 尝试查找匹配的参数
        const nameBasedIndex = this.allParams.findIndex(
          p => p.name === edit.name
        );
        if (nameBasedIndex >= 0) {
          editIndex = nameBasedIndex;
        } else {
          params.paramIndex = this.allParams.length + 1;
          this.allParams.push(params);

          // 更新前置后置列表并触发change事件
          this.splitSelectedList();
          this.paramSelected();
          this.showRegis = false;
          return;
        }
      }
      this.allParams.splice(editIndex, 1, params);
    } else {
      // 新增模式 - 检查是否与任何已有字段重名
      const duplicate = this.allParams.find(d => d.name === params.name);

      if (duplicate) {
        this.$message.warning("字段名称不能重复");
        return;
      }

      // 新增字段
      params.paramIndex = this.allParams.length + 1;
      params.isShow = 1;
      this.allParams.push(params);
    }

    this.handleChangeBmi(this.allParams);

    // 更新前置后置列表
    this.splitSelectedList();

    // 重新计算paramIndex并触发change事件
    this.paramSelected();

    this.showRegis = false;
  }

  editClose() {
    this.showRegis = false;
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      // 检查所有作为条件的字段是否为单选或多选类型
      const conditionFields = new Map(); // Map<paramIndex, Array<dependent field names>>

      // 收集所有作为条件的字段和依赖它们的字段
      this.allParams.forEach(param => {
        if (param.showConfigList && param.showConfigList.length) {
          param.showConfigList.forEach(config => {
            if (config && config[0] && config[0].matchParamIndex) {
              const matchParamIndex = config[0].matchParamIndex;
              if (!conditionFields.has(matchParamIndex)) {
                conditionFields.set(matchParamIndex, []);
              }
              conditionFields.get(matchParamIndex).push(param.name);
            }
          });
        }
      });

      // 检查这些字段的类型是否为单选或多选
      for (const [paramIndex, dependents] of conditionFields.entries()) {
        const conditionParam = this.allParams.find(
          p => p.paramIndex === paramIndex
        );
        if (
          conditionParam &&
          !["choice", "multiChoice"].includes(conditionParam.inputType)
        ) {
          const dependentNames = dependents.join("、");
          this.$message.error(
            `字段"${conditionParam.name}"被字段"${dependentNames}"用作显示条件，必须设置为单选或多选类型`
          );
          resolve("params");
          return;
        }
      }

      // 检查条件显示的选项值是否存在于父级字段的选项中
      let hasInvalidOption = false;
      this.allParams.forEach(param => {
        if (param.showConfigList && param.showConfigList.length) {
          param.showConfigList.forEach(config => {
            if (config && config[0]) {
              const { matchParamIndex, matchValue } = config[0];
              const parentField = this.allParams.find(
                p => p.paramIndex === matchParamIndex
              );

              if (parentField) {
                let optionExists = false;

                // 检查选项是否存在
                if (parentField.inputType === "choice") {
                  optionExists = parentField.singleChoiceOptions.includes(
                    matchValue
                  );
                } else if (parentField.inputType === "multiChoice") {
                  optionExists = parentField.mutiChoiceOptions.some(
                    option => option.key === matchValue
                  );
                }

                if (!optionExists) {
                  this.$message.error(
                    `字段"${param.name}"的显示条件引用了字段"${parentField.name}"中不存在的选项"${matchValue}"`
                  );
                  hasInvalidOption = true;
                  resolve("params");
                  return;
                }
              }
            }
          });
        }
      });

      if (hasInvalidOption) return;

      if (this.formItemData.paramsSaveLater.use === 1) {
        const behindList = this.behindParams.filter(item => item.isShow === 1);

        if (!behindList.length) {
          resolve("params");
          this.$message.error("请选择面试结束语前登记信息");
          return;
        }
      }

      resolve("");
    });
  }
}
